export const container = () => ({});

export const extendContainer = ({ isBerlin }) => ({
    container: () => ({
        paddingTop: isBerlin ? '4rem' : '2.375rem',
        paddingBottom: isBerlin ? '0rem' : '4rem',

        tabletLarge: {
            paddingTop: isBerlin ? '10rem' : '2.375rem',
            paddingBottom: isBerlin ? '0rem' : '6.5625rem',
        },
    }),
});

export const extendAddressContainer = () => ({
    container: ({ theme: { colors } }) => ({
        backgroundColor: colors.bgGrey,
        paddingTop: '2rem',
        paddingLeft: '2rem',
        paddingBottom: '3rem',

        tabletLarge: {
            gridColumn: 'auto / span 12',
            display: 'flex',
        },

        '@media(min-width: 75.1875em)': {
            gridColumn: 'auto / span 8',
        },
    }),
});

export const extendInquiryContainer = ({ theme: { colors } }) => ({
    container: () => ({
        backgroundColor: colors.black,
        color: colors.white,
        padding: '1.25rem 1.5rem',
        position: 'relative',
    }),
});

export const inquiryMessage = {
    fontSize: '1.125rem',
    lineHeight: '1.635rem',
    fontWeight: 800,
};

export const inquiryCTA = ({ theme: { colors } }) => ({
    borderBottom: `2px solid ${colors.blue}`,
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',

    ':hover': {
        color: colors.blue,
    },
});

export const extendLink = {
    link: ({ theme: { colors } }) => ({
        color: colors.cyan,
        fontSize: '1.0625rem',
        fontWeight: 800,
        display: 'block',
        textAlign: 'right',
        marginTop: '1.25rem',
        textDecoration: 'none',
        marginLeft: 'auto',
    }),
};
